import { Image, ImageSource } from 'expo-image';
import { Platform, StyleSheet, View } from 'react-native';

import Text from '../Text';

interface ChatRoomHeaderProps {
  thumbnail: string | number | ImageSource | ImageSource[] | string[] | null | undefined;
  title: string;
  subtitle: string;
}

const ChatRoomHeader = ({ thumbnail, title, subtitle }: ChatRoomHeaderProps) => {
  return (
    <View style={styles.mainContainer}>
      <Image source={thumbnail} style={styles.thumb} />
      <View style={styles.content}>
        <View style={styles.titleContainer}>
          <Text numberOfLines={1} fontWeight="700" style={styles.title}>
            {title}
          </Text>
        </View>
        <Text numberOfLines={1} style={styles.subtitle}>
          {subtitle}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    width: Platform.OS === 'web' ? '100%' : '88%',
    flexDirection: 'row',
    justifyContent: Platform.OS === 'android' ? 'flex-start' : 'center',
    paddingLeft: Platform.OS === 'android' ? 10 : null,
    alignItems: 'center',
    gap: 10
  },

  thumb: {
    width: 36,
    height: 36,
    borderRadius: 20
  },

  content: {
    gap: 2
  },

  titleContainer: {
    flexDirection: 'row',
    maxWidth: '100%'
  },

  title: {
    color: 'black'
  },

  subtitle: {
    maxWidth: '100%'
  }
});

export default ChatRoomHeader;
